var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgHeartIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 56,
    height: 56,
    rx: 28,
    fill: "#6BE0BD"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6528 24.6715C17.7222 20.0668 23.0007 15.7951 28 21.8069C32.9993 15.7951 38.2779 20.0665 38.3473 24.6712C38.3473 31.5264 29.9783 37.1533 28 37.1533C26.0217 37.1533 17.6528 31.5267 17.6528 24.6715Z",
    stroke: "white",
    strokeWidth: 1.7136,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeartIcon);
export default __webpack_public_path__ + "static/media/heartIcon.73510790490e744f259800d9f5bc80a8.svg";
export { ForwardRef as ReactComponent };